import { render, staticRenderFns } from "./MosaicoGaleria.vue?vue&type=template&id=a0373d3a&scoped=true"
import script from "./MosaicoGaleria.vue?vue&type=script&lang=js"
export * from "./MosaicoGaleria.vue?vue&type=script&lang=js"
import style0 from "./MosaicoGaleria.vue?vue&type=style&index=0&id=a0373d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0373d3a",
  null
  
)

export default component.exports